var RoleEnum;
(function (RoleEnum) {
    RoleEnum["Teacher"] = "teacher";
    RoleEnum["Student"] = "student";
    RoleEnum["Guardian"] = "guardian";
    RoleEnum["Staff"] = "staff";
    RoleEnum["Shadow"] = "shadow";
})(RoleEnum || (RoleEnum = {}));
export {};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBK0RBLElBQUssUUFNSjtBQU5ELFdBQUssUUFBUTtJQUNYLCtCQUFtQixDQUFBO0lBQ25CLCtCQUFtQixDQUFBO0lBQ25CLGlDQUFxQixDQUFBO0lBQ3JCLDJCQUFlLENBQUE7SUFDZiw2QkFBaUIsQ0FBQTtBQUNuQixDQUFDLEVBTkksUUFBUSxLQUFSLFFBQVEsUUFNWiJ9